<template>
    <div
        class="lang-currency-changer header__hover text_11"
        v-click-outside="() => $emit('update:isShowLocales', false)"
        v-show="currentCountry && langs && countries && locale.currency">
        <div class="lang-currency-changer__handle" @click="$emit('update:isShowLocales', !isShowLocales)">
            <div class="lang-currency-changer__lang">{{ $i18n.locale }}/</div>
            <div class="lang-currency-changer__currency money">{{ currency }}</div>
        </div>
        <transition name="fade">
            <div class="lang-currency-changer__dropdown" v-if="isShowLocales">
                <div class="lang-currency-changer__col">
                    <div class="lang-currency-changer__label">{{ $t("country") }}</div>
                    <div class="lang-currency-changer__search">
                        <div class="form-group">
                            <Input
                                inputClass="text_11"
                                placeholder="поиск страны"
                                name="countrySearch"
                                v-model="countryQuery" />
                        </div>
                    </div>
                    <div class="lang-currency-changer__list" v-if="filteredCountries">
                        <perfect-scrollbar>
                            <div
                                class="lang-currency-changer__item"
                                :class="{ 'lang-currency-changer__item--current': key == currentCountry }"
                                v-for="(country, key) in filteredCountries"
                                :key="key"
                                @click="changeCountry(key)">
                                <span class="lang-currency-changer__name">{{ country.fullName }}</span>
                                <span class="money color-text_3">{{
                                    country.currency ? country.currency : country.currencyCode
                                }}</span>
                            </div>
                        </perfect-scrollbar>
                    </div>
                    <div class="lang-currency-changer__list" v-else>
                        <div class="lang-currency-changer__item lang-currency-changer__item--empty">
                            <div class="lang-currency-changer__name">{{ $i18n.t("nothinf_found") }}</div>
                            <div
                                v-if="countryQuery.toLowerCase() == 'zalupa' || countryQuery.toLowerCase() == 'залупа'">
                                ( ͡°( ͡° ͜ʖ ͡°( ͡❛ ︹ ͡❛) ͡° ͜ʖ ͡°) ͡°)
                            </div>
                        </div>
                    </div>
                    <div class="lang-currency-changer__label lang-currency-changer__label--end">
                        <nuxt-link :to="$device.isDesktop ? '/dostavka/' : '/pomosh-klientam/'">{{
                            $t("customer_help")
                        }}</nuxt-link>
                    </div>
                </div>
                <div class="lang-currency-changer__col">
                    <div class="lang-currency-changer__label">{{ $t("lang") }}</div>
                    <div class="lang-currency-changer__list lang-currency-changer__list--short">
                        <div
                            @click="changeLang(key)"
                            class="lang-currency-changer__item"
                            :class="{ 'lang-currency-changer__item--current': key == $i18n.locale }"
                            v-for="(lang, key) in langs"
                            :key="lang">
                            <span>{{ lang }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import Input from "~/components/form/Input";
import { mapGetters } from "vuex";
export default {
    name: "LangCurrencyChanger",
    components: { Input },
    data() {
        return {
            countryQuery: "",
        };
    },
    props: ["isShowLocales"],
    computed: {
        ...mapGetters({
            locale: "globalvars/getLocale",
            currency: "globalvars/getCurrency",
            langs: "globalvars/getLangs",
            countries: "globalvars/getCountries",
            currentCountry: "globalvars/getCurrentCountry",
        }),
        filteredCountries() {
            if (this.countryQuery != "") {
                let list = {};
                for (const key in this.countries) {
                    if (Object.hasOwnProperty.call(this.countries, key)) {
                        const element = this.countries[key];
                        if (element.fullName.toLowerCase().indexOf(this.countryQuery.toLowerCase()) + 1) {
                            list[key] = element;
                        }
                    }
                }
                if (Object.keys(list).length) {
                    return list;
                }
                return false;
            }
            return this.countries;
        },
    },
    methods: {
        changeCountry(country) {
            localStorage.setItem("savedCountry", country);
            this.$store.commit("globalvars/setCountry", country);
            this.$emit("update:isShowLocales", false);
        },
        changeLang(key) {
            localStorage.setItem("savedLanguage", key);
            this.$store.commit("globalvars/setLanguage", key);
            this.$i18n.setLocale(key);
            this.$emit("update:isShowLocales", false);
        },
    },
};
</script>
<style lang="less">
.lang-currency-changer {
    width: 45px;
    position: relative;
    &__handle {
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        .is_apple & {
            padding-top: 3px;
        }
    }
    &__dropdown {
        position: absolute;
        max-height: calc(100dvh - 36);
        top: 100%;
        right: 0;
        background: @bg;
        z-index: 5;
        display: flex;
        border: 1px solid @border2;
        // white-space: nowrap;
    }
    &__label {
        padding: 10px 24px 8px;
        color: @text_2;
        border-bottom: 1px @border2 solid;
        &--end {
            border-bottom: 0;
        }
    }
    &__item {
        padding: 16px 5px 0 0;
        order: 1;
        &:hover {
            color: @accent;
        }
        &--current {
            padding-top: 0;
            order: 0;
            > span:first-child {
                text-decoration: underline;
                text-decoration-skip-ink: none;
                text-underline-offset: 2px;
            }
        }
        &--empty {
            white-space: nowrap;
            padding-top: 0;
        }
    }
    &__list {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 13px 24px 24px;
        width: 203px;
        height: calc(41px * 6);
        overflow: hidden;
        + .lang-currency-changer__label {
            border-top: 1px @border2 solid;
        }
        &--short {
            width: 110px;
        }
    }
    &__col {
        & + & {
            border-left: 1px solid @border2;
        }
    }
    &__search {
        padding: 0 24px;
        margin-top: 7px;
        margin-bottom: 11px;
    }
    .ps {
        width: 155px;
        display: flex;
        flex-direction: column;
        &__thumb-y {
            width: 1px;
            background: @purple;
            right: 0;
        }
    }
}
</style>
